import { button } from "../dom";
import { identity, toolbar } from "./shared";
import type { AppState } from "../types";
import { publicOnlineCount } from "../presence";

export function home(state: AppState): string {
  return `<main class="home-screen" aria-label="Warlock main menu"><div class="home-shade"></div>${toolbar()}
    <div class="home-center"><h1 class="wordmark" aria-label="Warlock">WARL<span class="logo-o">O</span>CK</h1>
    <nav class="home-actions" aria-label="Play options">
      ${button("play", "Play", { primary: true })}${button("join", "Join room")}${button("create", "Create room")}
    </nav></div>${identity(state)}
    <div class="presence beveled"><span class="status-dot ${state.connected ? "online" : ""}"></span><span data-presence>${state.online == null ? "Connecting" : `${publicOnlineCount(state.online)} players online`}</span></div>
    ${state.engineError ? '<div class="engine-notice" role="alert">The arena could not load. <button class="text-button" data-action="reload">Reload game</button></div>' : ""}
    </main>`;
}
export function loader(): string {
  return '<main class="loader-screen" aria-label="Loading match"><span class="loader" role="status"><span class="sr-only">Finding and loading your match. Press Escape to cancel.</span></span></main>';
}
